import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"
import Table from "components/ui/Table"
import { STRING_TYPE } from "config"

const Content = () => {
  const HEADER = [
    {
      label: <strong>Slapuko pavadinimas ir (ar) turinys</strong>,
      field: "name",
      format: STRING_TYPE,
      minWidth: 100,
    },
    {
      label: <strong>Slapuko aprašymas</strong>,
      field: "description",
      format: STRING_TYPE,
      minWidth: 100,
    },
  ]

  const ITEMS = [
    {
      name: "Seanso slapukai",
      description:
        "Skirti naudotojo tapatybei ir prieigos teisei savitarnoje nustatyti.",
    },
    {
      name: "Trečiųjų šalių slapukai",
      description:
        "Analitiniai slapukai skirti duomenims apie naudotojo veiksmus savitarnoje rinkti, siekiant pagerinti naudotojo patirtį. Daugiau informacijos galite rasti čia Google Analytics.",
    },
  ]

  return (
    <Fragment>
      <Accordion>
        <Summary>Kas yra slapukai?</Summary>
        <Details>
          <Text>
            Slapukai yra nedideli tekstiniai failai, susidedantys iš raidžių ir
            skaičių, kurie yra atsiunčiami ir išsaugomi Jūsų kompiuteryje ar
            kitame įrenginyje (pvz., telefone ar planšetiniame kompiuteryje),
            kai lankotės interneto svetainėje. Jie gali būti naudojami Jūsų
            įvestiems duomenims ir nuostatoms (pvz., kalbos nustatymas)
            išsaugoti arba duomenims apie Jūsų aplankytus puslapius rinkti, kai
            naršote interneto svetainėje.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Kokius slapukus naudoja „Fresh Finance“?</Summary>
        <Details>
          <Text>
            „Fresh Finance“ naudoja kelių tipų slapukus, kurie skiriasi savo
            paskirtimi ir saugojimo trukme. Slapukai yra būtini siekiant
            užtikrinti interneto svetainės techninį funkcionalumą, palengvinti
            naudojimąsi ja, padidinti jos saugumą ir sukurti suasmenintą
            patirtį. Naudodami slapukus, galime užtikrinti geriausią patirtį
            lankantis savitarnoje, gauti įžvalgų apie klientų naudojimąsi mūsų
            interneto svetaine ir tobulinti mūsų siūlomas paslaugas.
          </Text>
          <Text>
            Saugojimo trukmė nurodo, kiek laiko slapukai išlieka aktyvūs Jūsų
            naršyklėje.
          </Text>
          <Text>„Fresh Finance“ naudoja trijų tipų slapukus:</Text>
          <Text>
            <ul>
              <li>
                <strong>1. Būtinieji slapukai</strong>
                <br />
                Būtinieji slapukai suteikia Jums prieigą prie skirtingų „Fresh
                Finance“ interneto svetainės dalių. Šie slapukai įrašomi Jūsų
                kompiuteryje, mobiliajame telefone, planšetiniame kompiuteryje
                ar kitame įrenginyje, kai lankotės mūsų interneto svetainėje. Be
                šių slapukų interneto svetainė negali veikti, todėl jų negalima
                išjungti. Būtinieji slapukai tvarkomi remiantis teisėtu
                interesu, todėl norint juos naudoti jokio sutikimo nereikia.
              </li>
              <li>
                <strong>2. Analitiniai slapukai</strong>
                <br />
                Analitinius slapukus naudojame apsilankymams ir srauto
                šaltiniams apskaičiuoti, jie padeda įvertinti ir pagerinti mūsų
                interneto svetainės veikimą. Naudodami šiuos slapukus galime
                matyti, kaip naudotojai naršo svetainėje ir kurie puslapiai
                lankomi dažniausiai. Jei atsisakysite šių slapukų, Jūsų
                apsilankymo mūsų statistikoje nesimatys.
              </li>
              <li>
                <strong>3. Naudotojo pasirenkamieji slapukai</strong>
                <br />
                Šie slapukai naudojami siekiant pagerinti Jūsų patirtį mūsų
                interneto svetainėje, teikti svarbią informaciją apie mūsų
                produktus ir paslaugas bei pagerinti tikslinę rinkodarą ir
                reklamą. Šie slapukai taip pat gali būti naudojami mūsų reklamos
                kampanijoms trečiųjų šalių interneto svetainėse, todėl galime
                gauti įžvalgų apie mūsų patikimų partnerių svetaines, kuriose
                susidūrėte su mūsų reklaminiais skelbimais. Jei nuspręsite
                atsisakyti šių slapukų, Jums rodomi skelbimai bus mažiau
                suasmeninti.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Sutikimas su slapukų naudojimu</Summary>
        <Details>
          <Text>
            Dėl tam tikrų analitinių ir naudotojo pasirenkamųjų slapukų taikymo,
            prašome Jūsų sutikimo. Šiuos slapukus naudojame siekdami teikti
            suasmenintą informaciją ir pagerinti mūsų interneto svetainės
            veikimą. Jei sutinkate su visais slapukais, spustelėkite „Sutinku“.
            Jei norite pasirinkti slapukus, su kurių naudojimu sutinkate,
            spustelėkite „Tinkinti slapukus“. Galite duoti arba atšaukti
            sutikimą naudoti slapukus ir koreguoti savo nuostatas iškylančiajame
            lange, užsukę į mūsų interneto svetainę.
          </Text>
          <Text>Jūsų slapukų nuostatos saugomos vienerius metus.</Text>
          <Text>
            Sutikdami su tam tikros kategorijos slapukų naudojimu, sutinkate su
            visų tos kategorijos slapukų naudojimu. Siekdama užtikrinti
            geriausią naudotojo patirtį, „Fresh Finance“ gali atnaujinti ir
            keisti slapukų naudojimo nuostatas, todėl slapukų sąrašas gali
            atitinkamai keistis.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Slapukų nuostatų keitimas arba atšaukimas</Summary>
        <Details>
          <Text>
            Galite bet kada pakoreguoti savo nuostatas, pasirinkdami slapukus,
            kuriuos leidžiate mums naudoti. Taip pat galite bet kada atšaukti
            savo sutikimą. Atminkite, kad slapukų ištrynimas ir (arba)
            blokavimas gali turėti įtakos Jūsų, kaip naudotojo, patirčiai. Tai
            gali paveikti naršyklės funkcionalumą ir tinkamą savitarnos funkcijų
            veikimą.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Duomenų tvarkymas</Summary>
        <Details>
          <Text>
            Jei tvarkome su slapukų naudojimu susijusius asmens duomenis, toks
            tvarkymas bus vykdomas pagal Privatumo pranešimą.
          </Text>
          <Text>
            Kaip naudotojas ir duomenų subjektas, Jūs turite teisę:
            <ul>
              <li>
                gauti patvirtinimą, ar „Fresh Finance“ tvarko Jūsų asmens
                duomenis, ir gauti prieigą prie tokių duomenų;
              </li>
              <li>apriboti ir keisti asmens duomenų tvarkymo apimtį;</li>
              <li>pareikalauti, kad asmens duomenys būtų ištrinti;</li>
              <li>
                nesutikti, kad duomenys būtų tvarkomi, jei asmens duomenys
                tvarkomi remiantis teisėtu „Fresh Finance“ interesu;
              </li>
              <li>
                bet kada atšaukti savo sutikimą dėl asmens duomenų tvarkymo;
              </li>
              <li>
                pateikti skundą dėl asmens duomenų tvarkymo Valstybinei duomenų
                apsaugos inspekcijai (www.vdai.lt), jei manote, kad dėl „Fresh
                Finance“ vykdomo tvarkymo pažeidžiami Jūsų teisės ir interesai
                pagal duomenų apsaugos įstatymus.
              </li>
            </ul>
          </Text>
          <Text>
            Norėdami pasinaudoti savo teisėmis, galite pateikti prašymą
            naudodamiesi savitarna arba išsiųsdami elektroniniu parašu
            pasirašytą užklausą elektroninio pašto adresu{" "}
            <a href="mailto:info@freshfinance.lt">info@freshfinance.lt</a>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Kontaktinė informacija</Summary>
        <Details>
          <Text>
            Jei turite klausimų dėl slapukų naudojimo ir pritaikymo, sutikimo
            atšaukimo ar su slapukais susijusių dalykų, susisiekite su mumis.
            Mūsų kontaktinius duomenis rasite „Fresh Finance“ interneto
            svetainėje.
          </Text>
          <Text>
            Taip pat galite susisiekti su mūsų duomenų apsaugos pareigūnu,
            išsiųsdami el. laišką adresu{" "}
            <a href="mailto:info@freshfinance.lt">info@freshfinance.lt</a>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Šio dokumento galiojimas</Summary>
        <Details>
          <Text>
            Slapukų politika yra parengta estų kalba ir išversta į anglų kalbą.
            Kilus su kalba ir aiškinimu susijusiems ginčams, nesutarimams ar
            klausimams, teisiškai privaloma šios Slapukų politikos versija yra
            versija estų kalba.
          </Text>
          <Text>
            Slapukų politika įsigalioja 2025 m. vasario 18 d. „Fresh Finance“
            pasilieka teisę bet kada vienašališkai keisti šią Slapukų politiką.
            Visi pakeitimai bus paskelbti, o naujausia versija bus pasiekiama
            adresu{" "}
            <a
              href="https://freshfinance.lt"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.freshfinance.lt
            </a>
            .
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Šiuo metu naudojami slapukai</Summary>
        <Details>
          <Table header={HEADER} items={ITEMS} fade={false} />
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
